var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1532 1.95713C20.5437 1.5666 20.5437 0.933429 20.1532 0.542898C19.7627 0.152367 19.1295 0.152367 18.739 0.542898L10.6972 8.58494L2.65546 0.542898C2.26495 0.152367 1.63179 0.152367 1.24127 0.542898C0.850755 0.933429 0.850755 1.5666 1.24127 1.95713L9.28305 9.99918L1.24015 18.0423C0.849637 18.4329 0.849637 19.066 1.24015 19.4566C1.63067 19.8471 2.26383 19.8471 2.65434 19.4566L10.6972 11.4134L18.7401 19.4566C19.1307 19.8471 19.7638 19.8471 20.1543 19.4566C20.5448 19.066 20.5448 18.4329 20.1543 18.0423L12.1114 9.99918L20.1532 1.95713Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/remove-cross.40088644262346ad630d26f039d67aa2.svg";
export { ForwardRef as ReactComponent };